<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          DYNAMIC HIERARCHY {{ isDraft ? 'DRAFT' : '' }}
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9
            >Dynamic Hierarchy {{ isDraft ? 'Draft' : '' }} List
          </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon @click="getData()">
              refresh
            </v-icon>
          </v-flex>
          <v-flex xs4 class="my-5">
            <v-text-field
              id="search"
              v-model="search"
              append-icon="search"
              label="Search by Division"
              single-line
              @keyup="searchGroup()"
              hide-details
            ></v-text-field>
          </v-flex>
          <!-- <v-flex
            xs8
            class="text-right"
            v-if="hasPermission('create_master_data', 'create')"
          >
            <v-btn
              v-if="!isDraft"
              id="add-brand"
              depressed
              color="secondblue"
              class="white--text"
              :to="{
                name: 'dynamic-hierarchy-create',
                params: { type: 'create' }
              }"
            >
              <v-icon left dark>add</v-icon>
              Add new hierarchy
            </v-btn>
          </v-flex> -->
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="progressDialogLoading"
          :search="search"
          :must-sort="true"
          :options.sync="options"
          :server-items-length="totalItems"
          :sort-desc.sync="descending"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 25]
          }"
        >
          <v-progress-linear
            slot="progress"
            color="primary"
            indeterminate
          ></v-progress-linear>
          <!-- <template v-slot:item.created_by="{ item }">
            {{
              item.logCreate
                ? item.logCreate.length > 0
                  ? item.logCreate[0].user.email
                  : '-'
                : '-'
            }}
          </template>
          <template v-slot:item.updated_by="{ item }">
            {{
              item.logUpdate
                ? item.logUpdate.length > 0
                  ? item.logUpdate[0].user.email
                  : '-'
                : '-'
            }}
          </template> -->
          <template v-slot:item.action="{ item }">
            <v-btn
              icon
              @click="toDetail(item.id)"
              :id="'btn-detail' + item.id"
              v-if="hasPermission('view_master_data', 'view')"
            >
              <v-icon color="green">remove_red_eye</v-icon>
            </v-btn>
            <v-btn
              icon
              @click="toEdit(item.id)"
              :id="'btn-edit' + item.id"
              v-if="hasPermission('update_master_data', 'update')"
            >
              <v-icon color="secondblue">mdi-square-edit-outline</v-icon>
            </v-btn>
            <!-- <v-btn
              :id="'btn-edit' + item.id"
              icon
              v-if="hasPermission('delete_master_data', 'delete')"
            >
              <v-icon color="red">mdi-delete</v-icon>
            </v-btn> -->
          </template>
          <template v-slot:no-data>
            <label>No data displayed</label>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../components/progress_dialog';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import ACLMixin from '../../mixins/ACLMixin';
import paginationMixin from '../../mixins/paginationMixin';

export default {
  components: { 'progress-dialog': ProgressDialog },
  mixins: [ACLMixin, paginationMixin],
  data() {
    return {
      progressDialogLoading: true,
      loading: true,
      descending: true,
      sort: '',
      totalItems: 0,
      options: {
        itemsPerPage: 5
      },
      search: '',
      isSearch: false,
      breadcrumbs: [
        {
          text: 'Organization Management',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Dynamic Hierarchy List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      page: 1,
      pageCount: 0,
      // itemsPerPage: 10,
      headers: [
        { text: 'Division', value: 'division.name' },
        { text: 'Total Group', value: 'group_count' },
        {
          text: 'Created At',
          value: 'created_at'
        },
        {
          text: 'Updated At',
          value: 'updated_at'
        },
        {
          text: 'Action',
          value: 'action',
          align: 'center',
          sortable: false
        }
      ],
      items: [],
      isDraft: false
    };
  },
  watch: {
    $route() {
      this.checkDraft();
      this.getData();
    },
    descending() {
      this.getData();
    }
  },
  mounted() {
    this.checkDraft();
    this.getData();
  },
  methods: {
    checkDraft() {
      let path = this.$route.path;
      let type = path.split('/');
      if (type[2] === 'draft') {
        this.isDraft = true;
        this.breadcrumbs[1].text = 'Dynamic Hierarchy Draft List';
        this.headers = [
          {
            text: 'Division',
            value: 'division.name',
            sortable: false
          },
          {
            text: 'Status',
            value: 'status',
            sortable: false
          },
          {
            text: 'Version',
            value: 'version',
            sortable: false
          },
          {
            text: 'Created At',
            value: 'created_at',
            sortable: false
          },
          {
            text: 'Created By',
            value: 'createdBy.email',
            sortable: false
          },
          {
            text: 'Updated At',
            value: 'updated_at',
            sortable: false
          },
          {
            text: 'Action',
            value: 'action',
            align: 'center',
            sortable: false
          }
        ];
      } else {
        this.isDraft = false;
        this.breadcrumbs[1].text = 'Dynamic Hierarchy List';
        this.headers = [
          {
            text: 'Division',
            value: 'division.name',
            sortable: false
          },
          {
            text: 'Total Group',
            value: 'group_count',
            sortable: false
          },
          {
            text: 'Created At',
            value: 'created_at',
            sortable: false
          },
          {
            text: 'Updated At',
            value: 'updated_at',
            sortable: false
          },
          {
            text: 'Action',
            value: 'action',
            align: 'center',
            sortable: false
          }
        ];
      }
    },
    getData() {
      this.progressDialogLoading = true;
      this.loading = true;
      let { page, itemsPerPage } = this.options;
      if (this.isSearch) {
        page = 1;
      }
      if (this.descending) {
        this.sort = 'desc';
      } else {
        this.sort = 'asc';
      }
      const sort = this.sort;
      let endpoint = '';
      if (this.isDraft) {
        endpoint = 'dynamic/getDraftHierarchy';
      } else {
        endpoint = 'dynamic/getHierarchy';
      }
      return this.$store
        .dispatch(endpoint, {
          page,
          sort,
          limit: itemsPerPage,
          search: { name: this.search }
        })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          this.isSearch = false;
          if (data.code === 200) {
            this.items = data.data.result;
            this.totalItems = data.data.total_data;
            // this.options = data.data.pagination;
            page = data.data.pagination.current_page;
            itemsPerPage = data.data.pagination.per_page;
            this.options = { page, itemsPerPage };
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    searchGroup() {
      this.isSearch = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getData();
      }, 900);
    },
    toDetail(val) {
      this.$router.push({
        name: this.isDraft
          ? 'draft-hierarchy-detail'
          : 'dynamic-hierarchy-detail',
        params: { id: val }
      });
    },
    toEdit(val) {
      this.$router.push({
        name: this.isDraft ? 'draft-hierarchy-edit' : 'dynamic-hierarchy-edit',
        params: { type: 'edit', id: val }
      });
    }
  }
};
</script>
